<template>
  <div>
    <div v-for="item in tItems" :key="item.field">
      <mdb-input type="text" :value="$t(item.field)"
                 disabled
                 :label="item.name">
        <translate-modal slot="append" :category="item.category" :sub-category="item.subCategory"
                         :name="item.name"/>
      </mdb-input>
    </div>

  </div>

</template>
<script>
import {mdbBtn, mdbIcon, mdbInput} from 'mdbvue';
import translateModal from "./TranslateModal";
import api from "../../services/groupsPlaceApi";

export default {
  name: 'translateSection',
  components: {
    mdbIcon,
    mdbBtn,
    mdbInput,
    translateModal
  },
  props: {
    items: {
      type: Array,
      default: null
    },
    category: {
      type: String,
      default: null
    },
    subCategory: {
      type: String,
      default: null
    }
  },
  mounted() {
    if (this.items) {
      for (let item of this.items) {
        let t = {field: item}
        let parts = item.split(".")
        t.category = parts[0]
        t.subCategory = parts[1]
        t.name = parts[2]
        this.tItems.push(t)
      }
    }
    if (this.category && this.subCategory) {
      this.$store.dispatch("setExecuting", true)
      api.get("/admin/translateSubCategoryItems?category=" + this.category + "&subcategory=" + this.subCategory).then(
        (details) => {
          for (let item of details.data) {
            let t = {field: item}
            let parts = item.split(".")
            t.category = parts[0]
            t.subCategory = parts[1]
            t.name = parts[2]
            this.tItems.push(t)
          }
        },
        (error) => {

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }


  },
  data() {
    return {
      tItems: []
    }
  }


};
</script>
